import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/contexts/LangContext";

export default function AdminContacts() {
  const { t } = useLang();
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/contacts").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.put(`/admin/contacts/${id}/read`);
    load();
  };

  const del = async (id) => {
    if (!window.confirm("¿Eliminar este mensaje?")) return;
    await api.delete(`/admin/contacts/${id}`);
    toast.success("Mensaje eliminado");
    load();
  };

  return (
    <div data-testid="admin-contacts-page">
      <header className="mb-8">
        <p className="tracking-eyebrow text-[var(--eafg-muted)]">Bandeja de entrada</p>
        <h1 className="font-serif-display text-5xl mt-2">{t("admin.contacts")}</h1>
      </header>

      <div className="space-y-4">
        {items.map((m) => (
          <div
            key={m.id}
            className={`border bg-white p-5 ${m.read ? "border-[var(--eafg-line)]" : "border-[var(--eafg-copper)]"}`}
            data-testid={`admin-contact-${m.id}`}
          >
            <div className="flex items-start justify-between mb-3 gap-4">
              <div>
                <h3 className="font-serif-display text-xl">{m.name} {m.surname}</h3>
                <p className="text-sm text-[var(--eafg-muted)]">
                  {m.email}{m.phone && ` · ${m.phone}`} · {new Date(m.created_at).toLocaleString()}
                </p>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                {!m.read && (
                  <button
                    onClick={() => markRead(m.id)}
                    className="text-sm tracking-eyebrow hover:text-[var(--eafg-copper)] whitespace-nowrap"
                  >
                    Marcar como leído
                  </button>
                )}
                <button
                  onClick={() => del(m.id)}
                  className="text-[var(--eafg-muted)] hover:text-red-600 transition-colors"
                  title="Eliminar mensaje"
                  data-testid={`admin-contact-delete-${m.id}`}
                >
                  <Trash2 size={15} strokeWidth={1.5} />
                </button>
              </div>
            </div>
            <p className="text-[var(--eafg-ink)] whitespace-pre-line">{m.question}</p>
          </div>
        ))}
        {items.length === 0 && (
          <p className="text-[var(--eafg-muted)]">Sin mensajes todavía.</p>
        )}
      </div>
    </div>
  );
}
